import React from "react";
import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import Pharma from "../../component/solutionscomponent/Pharma";

const PharmaPage = () => {
  return (
    <>
      <section className="usp_service_section">
        <Navbar />
        <Pharma />
        <Footer />
      </section>
    </>
  );
};

export default PharmaPage;
